export default __webpack_public_path__ + "static/media/placeholder.a1d304c0.png";